$ = require 'jquery'
Browser = require '@trello/browser'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
Util = require 'lib/util'

# Safari doesn't respect tabindex for some elements unless you've enabled the
# Preferences > Advanced > Press Tab to highlight each item on a webpage
# This can cause behavior that we don't expect, so attempt to force safari to
# behave like other browsers
if Browser.isSafari()
  $(document).on 'keydown', (e) ->
    key = Keyboard.getKey(e)
    if key != Keys.Tab || e.metaKey || e.shiftKey || e.ctrlKey
      return

    $target = $(e.target)

    if !$target.attr('tabindex')
      return

    initialIndex = parseInt($target.attr('tabindex'), 10)

    $tabParent = $target.closest('body,.js-tab-parent')

    $tabElements = $tabParent.find('[tabindex]')

    $best = null
    $first = null
    bestIndex = Infinity
    firstIndex = Infinity

    $tabElements.each ->
      testIndex = parseInt($(@).attr('tabindex'), 10)
      if initialIndex < testIndex < bestIndex
        bestIndex = testIndex
        $best = $(@)
        foundAfter = true

      if !$best? && testIndex < firstIndex
        firstIndex = testIndex
        $first = $(@)

    $best ?= $first

    if $best?
      Util.stop(e)
      $best.focus()

    return



// WEBPACK FOOTER //
// ./app/scripts/init/safari-tab-index.coffee